import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IMG from 'ASSETS/zombie.svg';
import './ErrorBoundary.less';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  // eslint-disable-next-line no-unused-vars
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Error caught in ErrorBoundary:', error);
    // eslint-disable-next-line no-console
    console.error('Component stack trace:', info.componentStack);

    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-content">
          <div className="left-content">
            <IMG width="200" />
          </div>
          <div className="right-content">
            <span className="error-type">Whoops!</span>
            <span className="error-title">Something unexpected happened</span>
            <span className="error-desc">Please reload and try again</span>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.defaultProps = {};

ErrorBoundary.propTypes = {
  children: PropTypes.any.isRequired,
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.js